import React, {useEffect, useRef, useState} from "react";
import CustomTable from "../components/core/CustomTable";
import {useTheme} from "@mui/material/styles";
import {claimListHeaderStyle, tableColums} from "../constants/ClaimListTableColumns";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Card,
    CircularProgress,
    Grid,
    Skeleton,
    TablePagination,
} from "@mui/material";
import Header from "../components/core/Header";
import {getClaimListData, getInfoList, getMetaDataList, markAssignedClaim, rerunClaim} from "../utils/API";
import Search from "../components/Search";
import Stats from "../components/Stats";
import SnackbarComponent from "../components/core/Snackbar";
import SelectComponent from "../components/core/SelectComponent";
import ReRunClaim from "../components/ReRunClaim";
import EditClaim from "../components/EditClaim";
import InsightsIcon from "@mui/icons-material/Insights";
import CloseIcon from "@mui/icons-material/Close";
import TableShimmerEffect from "../components/core/TableShimmerEffect";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NotificationSound from "../assets/notification-sound.mp3";
import {readStoredCount, storeCount} from "../utils/handlers";
import {
    getLocalStorageHospitalCode,
    isAbhiInsurer,
    isAdminUser,
    isNotInsurerReadOnlyUser,
    isVitrayaInternalUser
} from "../constants/UserAuth";

function Dashboard() {
    const audioPlayer = useRef(null);
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [statsData, setStatsData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [tableDataAssigned, setTableDataAssigned] = useState([]);
    let FilterTableColums = [];
    const [procedureData, setProcedureData] = useState([]);
    const [metaData, setMetaData] = useState([]);
    const [searchInfo, setSearchInfo] = useState("");
    const [pageSize, setPageSize] = useState(50);
    const [page, setPage] = useState(0);
    const [rerunListOfId, setRerunListOfId] = useState([]);
    const [selectedListOfTableData, setSelectedListOfTableData] = useState([]);
    const [showStats, setShowStats] = useState(false);
    const [loadingStats, setLoadingStats] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [showSanckBar, setShowSnackbar] = useState({
        status: false,
        message: "",
        severity: "",
    });


    const collectForRerun = (data) => {
        setRerunListOfId(data);
    };
    const columnsToExclude = [
        "Actions",
        "Module Status",
        "Last Updated Date",
        "Claim Id",
    ];
    const abhiColumnsToExclude = [
        "Actions",
        "Module Status",
        "Claim Type",
        // "Last Updated Date",
        "Claim Id",
        "Status",
    ];
    //Add Columns if user is  Admin
    const ActionPresent = tableColums.some((obj) => obj.title === "Actions");
    if (
        isVitrayaInternalUser() && !ActionPresent
    ) {
        tableColums.push({
            title: "Actions",
            field: "id",
            cellStyle: {
                maxWidth: "0.2rem",
            },
            sorting: false,

            align: "center",
            render: (rowData) =>
                rowData &&
                rowData.id &&
                isVitrayaInternalUser() && (
                    <>
                        {
                            isAdminUser() && <div style={{marginBottom: "5px", width: "30px"}}>
                                <ReRunClaim
                                    claimId={rowData.id}
                                    corporateCode={getLocalStorageHospitalCode()}
                                    setRefresh={setRefresh}
                                    disabled={
                                        (rowData?.combinedStatus === "ENHANCEMENT_IN_PROGRESS" || rowData.insurerVisible)
                                    }
                                />
                            </div>
                        }
                        <div style={{marginTop: "5px"}}>
                            <EditClaim
                                // procedureList={procedureData}
                                hospitalId={rowData?.hospitalId}
                                // roomList={metaData?.hospitalServiceList}
                                // pedList={metaData?.illnessList || []}
                                treatmentList={[
                                    {id: "SURGICAL", name: "Surgical"},
                                    {id: "MEDICAL", name: "Medical"},
                                ]}
                                // reasonsForHospitalisation={metaData?.medicalEventList}
                                selectedProcedure={{
                                    id: rowData.procedureId,
                                    name: rowData.procedureName,
                                }}
                                selectedRoomType={rowData?.roomType}
                                selectedTreatmentType={rowData?.treatmentType}
                                selectedIllnessType={rowData?.illnessId}
                                selectedsecondaryIllnessType={rowData?.secondaryIllnessId}
                                selectedtertiaryIllnessType={rowData?.tertiaryIllnessId}
                                selectedReasonForHospitalization={rowData?.reasonForHospitalization || ''}
                                selectedPEDList={rowData?.pedList || []}
                                claimId={rowData.id}
                                claimPedList={rowData?.pedList || []}
                                disabled={rowData.insurerVisible}
                                selectedUnDisclosedPedType={rowData?.unDisclosedPEDId}
                                selectedUnDisclosedPedDuration={rowData?.unDisClosedPEDuration}
                                gplavalue={rowData?.gpla}
                            />
                        </div>
                    </>
                ),
        });
    }
    //Remove Columns if user is not Admin
    if (
        !isVitrayaInternalUser() && isAbhiInsurer()
    ) {
        FilterTableColums = tableColums.filter(
            (column) => !columnsToExclude.includes(column.title)
        );
    }
    //Remove Status if user is not Admin ABHI user
    if (
        !isVitrayaInternalUser() && isAbhiInsurer()
    ) {
        FilterTableColums = tableColums.filter(
            (column) => !abhiColumnsToExclude.includes(column.title)
        );
    }

    // Initlize table and stats Data
    useEffect(() => {
        setShowStats(false);
        setTableData([]);
        setTableDataAssigned([]);
        // fetchMetaData();
    }, []);

    useEffect(() => {
        // Fetching table data based on different criteria

        searchInfo.attributeValue === "" && setStatsData([]);

        searchInfo && searchInfo.startDate && searchInfo.endDate && fetchData();

        const fetchInterval = setInterval(() => {
            refreshData();
        }, 60000);

        return () => {
            clearInterval(fetchInterval);
        };
    }, [
        searchInfo,
        pageSize,
        page,
        showSanckBar.status === true,
        refresh === true,
    ]);
    // Fetching stats data based on different criteria

    useEffect(() => {
        showStats === true &&
        searchInfo &&
        searchInfo.startDate &&
        searchInfo.endDate &&
        searchInfo.attributeValue === "" &&
        fetchInfoData({
            startDate:
                searchInfo &&
                searchInfo.startDate &&
                searchInfo.startDate.replace("T00:00:00", ""),
            endDate:
                searchInfo &&
                searchInfo.endDate &&
                searchInfo.endDate.replace("T23:59:59", ""),
            dateType: searchInfo?.dateType,
        });
    }, [showStats]);

    // This method used to fetch table data from api

    function checkAndPlaySound(totalClaimCount = 0) {
        const totalClaimCountCurrent = localStorage.getItem("totalTableCount");
        if (totalClaimCountCurrent && parseInt(totalClaimCount) > parseInt(totalClaimCountCurrent)) {
            playSound();
        }
    }

    const fetchData = async () => {
        setLoading(true);
        const tableListData = await getClaimListData(
            searchInfo.startDate,
            searchInfo.endDate,
            searchInfo.attributesNames,
            searchInfo.attributeValue,
            searchInfo.dateType,
            pageSize,
            page
        );
       
        setLoading(false);
        checkAndPlaySound(tableListData?.totalClaimCount);

        storeCount("totalTableCount", tableListData?.totalClaimCount);
        storeCount("totalTableCountAssigned", tableListData?.totalClaimCountAssigned);
        setTableData(
            tableListData?.claimDataList !== null ? tableListData?.claimDataList : []
        );
        setTableDataAssigned(
            tableListData?.claimDataListAssigned !== null ? tableListData?.claimDataListAssigned : []
        );
    };
    // This method used to fetch table data from api
    const refreshData = async () => {
        const tableListData = await getClaimListData(
            searchInfo.startDate,
            searchInfo.endDate,
            searchInfo.attributesNames,
            searchInfo.attributeValue,
            searchInfo.dateType,
            pageSize,
            page
        );

        checkAndPlaySound(tableListData?.totalClaimCount);
        storeCount("totalTableCount", tableListData?.totalClaimCount);
        storeCount("totalTableCountAssigned", tableListData?.totalClaimCountAssigned);
        setTableData(
            tableListData?.claimDataList !== null ? tableListData?.claimDataList : []
        );
        setTableDataAssigned(
            tableListData?.claimDataListAssigned !== null ? tableListData?.claimDataListAssigned : []
        );
    };
    // This method used to fetch stats data from api
    const fetchInfoData = async (props) => {
        setLoadingStats(true);
        const infoData = await getInfoList(
            props.startDate?.split("T")[0],
            props.endDate?.split("T")[0],
            props.dateType
        );
        setStatsData(infoData.data);

        setLoadingStats(false);
    };
    // This method used to fetch meta data from api

    useEffect(() => {
        fetchMetaData();
    }, []);

    const fetchMetaData = async (props) => {
        const metaData = await getMetaDataList(true);
        setProcedureData(metaData.data["procedureList"]);
        const updatedResponseData = {
            ...metaData.data, // Keep all other properties of response.data
            // medicalEventList: metaData.data.medicalEventList.map(event => ({
            //     id: event.name, // Replace id with name
            //     name: event.name, // Keep the name field unchanged
            // })),
        };
        //setMetaData(metaData.data);
        setMetaData(updatedResponseData);
        const copay = JSON.stringify(metaData.data.copayZoneList);
        localStorage.setItem("copayZones", copay);
    };
    // This method used to change pages in the pagination
    const handleChangePage = (event, newPage) => {
        const uniqueListofId = [...new Set(rerunListOfId)];
        setSelectedListOfTableData(uniqueListofId);
        setPage(newPage);
    };
    // This method used to change pages in the rows per page
    const handleChangeRowsPerPage = (event) => {
        setPageSize(parseInt(event.target.value, 10));
        setPage(0);
    };
    // This method used to rerun the claims
    const rerun = async (props) => {
        if (props.claimFlow) {
            let ids = rerunListOfId.map((x) => x.id).toString();

            const response = await rerunClaim({
                claimFlow: props.claimFlow,
                claimId: ids,
                corporateCode: getLocalStorageHospitalCode(),
            });

            if (response) {
                setRerunListOfId([]);
                setRefresh(true);
            }
        }
    };

    const handleMarkAssigned = async () => {
        let ids = rerunListOfId.map((x) => x.id).toString();
        const response = await markAssignedClaim({
            claimId: ids,
            corporateCode: getLocalStorageHospitalCode(),
        });

        if (response) {
            setRerunListOfId([]);
            setRefresh(true);
        }
    };

    // This method used to remove the dublicates from claim list at selection of reruns
    function removeDuplicates(array) {
        const uniqueArray = array.filter(
            (obj, index, self) => index === self.findIndex((o) => o.id === obj.id)
        );
        return uniqueArray;
    }

    function playSound() {
        audioPlayer.current.play();
    }

    return (
        <Box
            sx={{
                background: theme.palette.background.default,
                minHeight: "100vh",
            }}
        >
            <audio ref={audioPlayer} src={NotificationSound}/>
            <Header setShowSanckBar={setShowSnackbar}/>
            <Grid
                container
                style={{
                    padding: "1rem",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "space-between",
                }}
            >
                <Search
                    metaData={metaData}
                    setSearchInfo={setSearchInfo}/>
            </Grid>
            <Grid style={{padding: "0 1rem"}}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setShowStats(!showStats)}
                    endIcon={showStats === false ? <InsightsIcon/> : <CloseIcon/>}
                >
                    {showStats === false ? "Show Summary" : "Close Summary"}
                </Button>
            </Grid>
            {/* )} */}

            {showStats === true && (
                <Card
                    style={{
                        margin: "1rem",
                        // padding: "1rem",
                        whiteSpace: "nowrap",
                        justifyContent: "space-between",
                        alignContent: "space-between",
                    }}
                >
                    {loadingStats === false && <Stats data={statsData}/>}
                    {loadingStats === true && (
                        <Grid textAlign={"center"}>
                            <CircularProgress/>
                        </Grid>
                    )}
                </Card>
            )}

            <Grid
                item
                style={{
                    display: "flex",
                    alignContent: "space-between",
                    justifyContent: "flex-end",
                    marginRight: 20,
                }}
            >
                {isVitrayaInternalUser() &&
                    <Grid sx={{minWidth: "400px", marginRight: "20px"}}>
                        {loading === false && rerunListOfId.length > 0 && (
                            <SelectComponent
                                label={"Rerun Options"}
                                menuItem={[
                                    {id: "RESTART_ALL", name: "Restart All Module"},
                                    // { id: "RESTART_BILL_TARIFF", name: "Restart Bill Tariff" },
                                    {id: "RESTART_PML", name: "Restart PML"},
                                    {id: "RESTART_VNEURON", name: "Restart vNeuron"},
                                    {
                                        id: "RESTART_BILL_TARIFF_AND_PML",
                                        name: "Restart Bill Tariff and PML",
                                    },
                                    // {
                                    //   id: "RESTART_BILL_TARIFF_AND_VNEURON",
                                    //   name: "Restart Bill Tariff and VNeuron",
                                    // },
                                    // {
                                    //   id: "RESTART_PML_AND_VNEURON",
                                    //   name: "Restart PML and VNeuron",
                                    // },
                                ]}
                                setSelections={(type) => rerun({claimFlow: type})}
                                style={{margin: 0}}
                            />
                        )}
                    </Grid>}
            </Grid>
            <Grid
                container
                style={{
                    padding: "1rem",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "space-between",
                }}>
                <Accordion style={{width: "100%", marginTop: "10px"}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        Unassigned Claims
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid sx={{minWidth: "100px", marginRight: "10px"}}>
                            {isNotInsurerReadOnlyUser() && loading === false && rerunListOfId.length > 0 && (
                                <Button
                                    style={{float: "right"}}
                                    variant="contained"
                                    color="primary"
                                    onClick={handleMarkAssigned}
                                    sx={{textAlign: "center"}}>
                                    Assign
                                </Button>
                            )}
                        </Grid>
                        <Grid>
                            {loading === false ? (
                                <Grid style={{padding: "0 1.5rem", textAlign: "right"}} elevation={1}>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 15, 30, 50, 75, 100]}
                                        colSpan={3}
                                        count={readStoredCount("totalTableCount")}
                                        rowsPerPage={pageSize}
                                        page={page}
                                        component="div"
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        labelRowsPerPage="Claims per Page"
                                        showLastButton={true}
                                        showFirstButton={true}
                                        align={"right"}
                                    />
                                </Grid>
                            ) : (
                                <Grid justifyContent={"flex-end"} alignItems={"flex-end"}>
                                    <Skeleton variant="rect" width={600} height={50}/>
                                </Grid>
                            )}
                        </Grid>
                        <Grid style={{padding: "0 1.5rem", marginBottom: "2rem" }} elevation={3}>
                            {loading === false ? (
                                <CustomTable
                                    tableColumns={
                                        isVitrayaInternalUser()
                                            ? tableColums
                                            : FilterTableColums
                                    }
                                    tableData={removeDuplicates(
                                        selectedListOfTableData.concat(tableData)
                                    )}
                                    selectedRows={rerunListOfId}
                                    // title="POC Data"
                                    isDownload={true}
                                    setPageSize={setPageSize}
                                    collectForRerun={collectForRerun}
                                    layout={"fixed"}
                                    headerStyle={claimListHeaderStyle}
                                    selection={isNotInsurerReadOnlyUser()}
                                    options={{
                                        rowStyle: {
                                            backgroundColor: '#01579b',
                                            color: '#FFF'
                                        }
                                    }}
                                />
                            ) : (
                                <TableShimmerEffect tableColums={tableColums}/>
                            )}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
                <Accordion style={{width: "100%", marginTop: "10px"}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        Assigned Claims
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid>
                            {loading === false ? (
                                <Grid style={{padding: "0 1.5rem", textAlign: "right" }} elevation={1}>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 15, 30, 50, 75, 100]}
                                        colSpan={3}
                                        count={readStoredCount("totalTableCountAssigned")}
                                        rowsPerPage={pageSize}
                                        page={page}
                                          component="div"
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        labelRowsPerPage="Claims per Page"
                                        showLastButton={true}
                                        showFirstButton={true}
                                        align={"right"}
                                    />
                                </Grid>
                            ) : (
                                <Grid justifyContent={"flex-end"} alignItems={"flex-end"}>
                                    <Skeleton variant="rect" width={600} height={50}/>
                                </Grid>
                            )}
                        </Grid>
                        <Grid style={{padding: "0 1.5rem", marginBottom: "2rem" }} elevation={3}>
                            {loading === false ? (
                                <CustomTable
                                    tableColumns={
                                        isVitrayaInternalUser()
                                            ? tableColums
                                            : FilterTableColums
                                    }
                                    tableData={removeDuplicates(
                                        selectedListOfTableData.concat(tableDataAssigned)
                                    )}
                                    selectedRows={rerunListOfId}
                                    // title="POC Data"
                                    isDownload={true}
                                    setPageSize={setPageSize}
                                    collectForRerun={collectForRerun}
                                    layout={"fixed"}
                                    headerStyle={claimListHeaderStyle}
                                    selection={false || isVitrayaInternalUser()}
                                />
                            ) : (
                                <TableShimmerEffect tableColums={tableColums}/>
                            )}
                        </Grid>
                    </AccordionDetails>
                </Accordion>

            </Grid>

            <SnackbarComponent
                show={showSanckBar.status}
                message={showSanckBar.message}
                severity={showSanckBar.severity}
            />
        </Box>
    );
}

export default Dashboard;
